<template>
    <div
        class="flex flex-col bg-whiteish hover:bg-pale-grey transition ease-in-out duration-300">
        <featured-media-component
            size="medium"
            :media="article.featured_media"
            :link="ARTICLE_LINK(slug, article)"
            :short-headline="article.title"
            class="w-full h-187px sm:h-370px lg:h-screen lg:max-h-375px bg-cover bg-center flex-shrink-0"
            style="aspect-ratio: 1 / 1;" />

        <a 
            :href="ARTICLE_LINK(slug, article)" 
            class="flex flex-col justify-between flex-grow p-5 md:p-8">
            <div>
                <h2 class="text-30px sm:text-40px text-waheed text-black-two">{{ article.short_headline }}</h2>
                <p class="mt-4 text-faseyha text-18px text-black-two leading-8 sm:leading-10 mb-8">{{ article.first_paragraph }}</p>
            </div>
            <article-meta-component
                :article="article" />
        </a>
    </div>
</template>

<script>
import ArticleMetaComponent from '../../../Layout/ArticleMetaComponent.vue'
import FeaturedMediaComponent from '../../../Layout/FeaturedMedia/FeaturedMediaComponent.vue'

export default{
    props: {
        article: {
            type: Object,
        },
        slug: {
            type: String,
        },
        classes: {
            type: String,
            default: '',
        }
    },
    components: {
        FeaturedMediaComponent,
        ArticleMetaComponent
    }
}
</script>
